/**
 *
 * @module bookmarksQuery
 *
 */

import Check from 'check-types';
import Exception from './../../services/exception/entry';
import GraphQlQuery from './../graphQlQuery';
import ContentQuery from './../contentQuery';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class BookmarksQuery
 *
 */
export default class BookmarksQuery extends ContentQuery {

    /**
     *
     * @param {GraphQlQuery} query
     *
     */
    constructor(query) {

        const errorMessage = {
            ctor: 'BookmarksQuery(query)',
            get query() {
                return `${this.ctor} needs GraphQlQuery instance`;
            }
        };

        instanceStrict(query, GraphQlQuery, errorMessage.query, InvalidArgumentException);

        super('bookmarks', query);

    }

}



// WEBPACK FOOTER //
// ./src/content/bookmarks/bookmarksQuery.js